// extracted by mini-css-extract-plugin
export default {"view":"HIWHxl5MeMecxSVLC94A","notAvailable":"zXastztgxFwSQMn2HzF3","edit":"VcIzWOUDuNj_cJqZBjuQ","delete":"Oa3CP6T94owmM3Y_DhYV"};